export const allStores = [
  {
    storeName: 'Tienda Flor 2',
    storeId: '1223345645',
    customerId: '3356789',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: ['pepsi', 'doritos'],
    createdDate: '2023-10-20',
    cutoffTime: '10:00',
    minimumOrderAmount: 10,
    points: '234'
  },
  {
    storeName: 'Tienda La Chiqui',
    storeId: '9872314568',
    customerId: '4789321',
    activeStatus: 'Inactive',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: ['pepsi', 'doritos'],
    createdDate: '2023-10-20',
    cutoffTime: '09:30',
    minimumOrderAmount: 10,
    points: '187'
  },
  {
    storeName: 'Panadería Claris Pan',
    storeId: '5463728190',
    customerId: '2198754',
    activeStatus: 'Active',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: ['pepsi', 'doritos'],
    createdDate: '2023-10-20',
    cutoffTime: '11:15',
    minimumOrderAmount: 10,
    points: '342'
  },
  {
    storeName: 'Tienda La Mora',
    storeId: '7891045623',
    customerId: '5674321',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2023-10-20',
    cutoffTime: '08:45',
    minimumOrderAmount: 10,
    points: '156'
  },
  {
    storeName: 'Virtual.com',
    storeId: '2134567890',
    customerId: '9876123',
    activeStatus: 'Inactive',
    deliveryDays: [],
    deliveryService: 24,
    productList: [],
    createdDate: '2023-10-20',
    cutoffTime: '12:00',
    minimumOrderAmount: 10,
    points: '429'
  },
  {
    storeName: 'Panadería Mar',
    storeId: '3456789012',
    customerId: '7654890',
    activeStatus: 'Inactive',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2023-10-20',
    cutoffTime: '09:15',
    minimumOrderAmount: 10,
    points: '201'
  },
  {
    storeName: 'Tienda El Goloso',
    storeId: '5678123490',
    customerId: '4325678',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2023-10-20',
    cutoffTime: '14:30',
    minimumOrderAmount: 10,
    points: '378'
  },
  {
    storeName: 'DeTodo.com',
    storeId: '9087654321',
    customerId: '1237654',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2023-10-20',
    cutoffTime: '10:45',
    minimumOrderAmount: 10,
    points: '265'
  },
  {
    storeName: 'Emimer',
    storeId: '4567890123',
    customerId: '8905432',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2022-10-20',
    cutoffTime: '13:00',
    minimumOrderAmount: 10,
    points: '192'
  },
  {
    storeName: 'Tienda Gama',
    storeId: '7654321098',
    customerId: '5643789',
    activeStatus: 'Active',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2022-10-20',
    cutoffTime: '11:30',
    minimumOrderAmount: 10,
    points: '307'
  },
  {
    storeName: 'Mercadito Rojo',
    storeId: '2345678901',
    customerId: '7891234',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2022-10-20',
    cutoffTime: '09:00',
    minimumOrderAmount: 10,
    points: '412'
  },
  {
    storeName: 'La Esquina Feliz',
    storeId: '8901234567',
    customerId: '3214567',
    activeStatus: 'Inactive',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2022-10-20',
    cutoffTime: '15:00',
    minimumOrderAmount: 10,
    points: '178'
  },
  {
    storeName: 'Abarrotes Luna',
    storeId: '1098765432',
    customerId: '6547890',
    activeStatus: 'Active',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2022-10-20',
    cutoffTime: '10:30',
    minimumOrderAmount: 10,
    points: '253'
  },
  {
    storeName: 'Tiendita Sierra',
    storeId: '6543210987',
    customerId: '2109876',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2022-10-20',
    cutoffTime: '12:45',
    minimumOrderAmount: 10,
    points: '321'
  },
  {
    storeName: 'MiniSuper Excel',
    storeId: '3210987654',
    customerId: '8765432',
    activeStatus: 'Inactive',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '08:30',
    minimumOrderAmount: 10,
    points: '147'
  },
  {
    storeName: 'Tienda Dulce',
    storeId: '9876543210',
    customerId: '4321567',
    activeStatus: 'Active',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '13:15',
    minimumOrderAmount: 10,
    points: '389'
  },
  {
    storeName: 'La Canasta',
    storeId: '5432109876',
    customerId: '9087123',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '14:00',
    minimumOrderAmount: 10,
    points: '276'
  },
  {
    storeName: 'Abasto Central',
    storeId: '2109876543',
    customerId: '5678901',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '11:45',
    minimumOrderAmount: 10,
    points: '195'
  },
  {
    storeName: 'Tienda Azul',
    storeId: '8765432109',
    customerId: '1234509',
    activeStatus: 'Inactive',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '09:45',
    minimumOrderAmount: 10,
    points: '283'
  },
  {
    storeName: 'Mercado Buena Vista',
    storeId: '4321098765',
    customerId: '7890123',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '12:30',
    minimumOrderAmount: 10,
    points: '367'
  },
  {
    storeName: 'Comercial Delgado',
    storeId: '0987654321',
    customerId: '3456789',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '10:15',
    minimumOrderAmount: 10,
    points: '214'
  },
  {
    storeName: 'Despensa Familiar',
    storeId: '7890123456',
    customerId: '9012345',
    activeStatus: 'Active',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '15:30',
    minimumOrderAmount: 10,
    points: '431'
  },
  {
    storeName: 'Tienda El Barrio',
    storeId: '3456789210',
    customerId: '6789012',
    activeStatus: 'Inactive',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '08:15',
    minimumOrderAmount: 10,
    points: '169'
  },
  {
    storeName: 'MiniMercado Veloz',
    storeId: '9012345678',
    customerId: '2345098',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '13:45',
    minimumOrderAmount: 10,
    points: '298'
  },
  {
    storeName: 'Abarrotería San José',
    storeId: '5678901234',
    customerId: '8901234',
    activeStatus: 'Active',
    deliveryDays: [],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '11:00',
    minimumOrderAmount: 10,
    points: '352'
  },
  {
    storeName: 'Tienda Los Amigos',
    storeId: '1234567890',
    customerId: '4567890',
    activeStatus: 'Inactive',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2023-10-20',
    cutoffTime: '16:00',
    minimumOrderAmount: 10,
    points: '183'
  },
  {
    storeName: 'Abarrotes Don Pedro',
    storeId: '6789012345',
    customerId: '1234567',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2023-10-20',
    cutoffTime: '09:30',
    minimumOrderAmount: 10,
    points: '415'
  },
  {
    storeName: 'SuperTienda Flores',
    storeId: '2345678109',
    customerId: '7654321',
    activeStatus: 'Active',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2023-10-20',
    cutoffTime: '14:15',
    minimumOrderAmount: 10,
    points: '227'
  },
  {
    storeName: 'La Esquina Perfecta',
    storeId: '8901234765',
    customerId: '3210987',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2023-10-20',
    cutoffTime: '10:45',
    minimumOrderAmount: 10,
    points: '341'
  },
  {
    storeName: 'Tienda El Ahorro',
    storeId: '4509876123',
    customerId: '9876543',
    activeStatus: 'Inactive',
    deliveryDays: ['Monday', 'Tuesday'],
    productList: [],
    createdDate: '2023-10-20',
    cutoffTime: '13:30',
    minimumOrderAmount: 10,
    points: '154'
  },
  {
    storeName: 'Mercadito Nuevo',
    storeId: '0123456789',
    customerId: '5432109',
    activeStatus: 'Active',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2023-10-20',
    cutoffTime: '11:15',
    minimumOrderAmount: 10,
    points: '278'
  },
  {
    storeName: 'Abarrotes La Gloria',
    storeId: '6543210789',
    customerId: '0987654',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2023-10-20',
    cutoffTime: '09:15',
    minimumOrderAmount: 10,
    points: '396'
  },
  {
    storeName: 'Tiendita Bonita',
    storeId: '2109875643',
    customerId: '6543210',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: null,
    productList: [],
    createdDate: '2023-10-20',
    cutoffTime: '15:45',
    minimumOrderAmount: 10,
    points: '205'
  },
  {
    storeName: 'La Favorita',
    storeId: '7654329108',
    customerId: '2109876',
    activeStatus: 'Inactive',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2023-10-20',
    cutoffTime: '12:15',
    minimumOrderAmount: 10,
    points: '317'
  },
  {
    storeName: 'Comercial Esperanza',
    storeId: '3210986754',
    customerId: '7890654',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2023-10-20',
    cutoffTime: '08:00',
    minimumOrderAmount: 10,
    points: '423'
  },
  {
    storeName: 'Abarrotes San Juan',
    storeId: '9012347856',
    customerId: '3456789',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2022-10-20',
    cutoffTime: '14:45',
    minimumOrderAmount: 10,
    points: '176'
  },
  {
    storeName: 'Tiendita Verde',
    storeId: '5432101876',
    customerId: '8901245',
    activeStatus: 'Active',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2022-10-20',
    cutoffTime: '10:30',
    minimumOrderAmount: 10,
    points: '329'
  },
  {
    storeName: 'Super Economía',
    storeId: '1098764532',
    customerId: '4567123',
    activeStatus: 'Inactive',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    productList: [],
    createdDate: '2022-10-20',
    cutoffTime: '13:00',
    minimumOrderAmount: 10,
    points: '245'
  },
  {
    storeName: 'Abasto Rápido',
    storeId: '6789013245',
    customerId: '0123456',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2022-10-20',
    cutoffTime: '09:00',
    minimumOrderAmount: 10,
    points: '382'
  },
  {
    storeName: 'El Buen Vecino',
    storeId: '2345671890',
    customerId: '6543219',
    activeStatus: 'Active',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2022-10-20',
    cutoffTime: '11:45',
    minimumOrderAmount: 10,
    points: '290'
  },
  {
    storeName: 'Tienda El Sol',
    storeId: '8765123409',
    customerId: '1234987',
    activeStatus: 'Active',
    // deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2022-10-20',
    cutoffTime: '',
    minimumOrderAmount: 10,
    points: '267'
  },
  {
    storeName: 'Mercado Popular',
    storeId: '3456789123',
    customerId: '7654321',
    activeStatus: 'Inactive',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2022-10-20',
    cutoffTime: '14:00',
    minimumOrderAmount: 10,
    points: '198'
  },
  {
    storeName: 'Abarrotes Juárez',
    storeId: '9012345876',
    customerId: '3216549',
    activeStatus: 'Active',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2022-10-20',
    cutoffTime: '',
    minimumOrderAmount: 10,
    points: '356'
  },
  {
    storeName: 'Tiendita del Barrio',
    storeId: '5678901243',
    customerId: '9876123',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2022-10-20',
    cutoffTime: '12:15',
    minimumOrderAmount: 10,
    points: '274'
  },
  {
    storeName: 'Minisuper Rápido',
    storeId: '1234568790',
    customerId: '5432198',
    activeStatus: 'Inactive',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: null,
    productList: [],
    createdDate: '2022-10-20',
    cutoffTime: '15:30',
    minimumOrderAmount: 10,
    points: '129'
  },
  {
    storeName: 'Abarrotes Santa Rosa',
    storeId: '7890564321',
    customerId: '2198765',
    activeStatus: 'Active',
    deliveryDays: ['Monday'],
    deliveryService: 12,
    productList: [],
    createdDate: '2022-10-20',
    cutoffTime: '08:45',
    minimumOrderAmount: 10,
    points: '403'
  },
  {
    storeName: 'Tienda La Fortuna',
    storeId: '2347890156',
    customerId: '7891234',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 12,
    productList: [],
    createdDate: '2022-10-20',
    cutoffTime: '11:00',
    minimumOrderAmount: 10,
    points: '315'
  },
  {
    storeName: 'Mercado Central',
    storeId: '8765432901',
    customerId: '4329876',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 12,
    productList: [],
    createdDate: '2022-10-20',
    cutoffTime: '13:30',
    minimumOrderAmount: 10,
    points: '237'
  },
  {
    storeName: 'Abarrotería López',
    storeId: '4321567890',
    customerId: '0987612',
    activeStatus: 'Inactive',
    deliveryDays: ['Monday'],
    deliveryService: 12,
    productList: [],
    createdDate: '2022-10-20',
    cutoffTime: '09:15',
    minimumOrderAmount: 10,
    points: '186'
  },
  {
    storeName: 'Tienda Los Pinos',
    storeId: '0123498765',
    customerId: '6547892',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 12,
    productList: [],
    createdDate: '2022-10-20',
    cutoffTime: '16:00',
    minimumOrderAmount: 10,
    points: '425'
  },
  {
    storeName: 'Abasto El Carmen',
    storeId: '6548901237',
    customerId: '2345167',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 12,
    productList: [],
    createdDate: '2022-10-20',
    cutoffTime: '10:15',
    minimumOrderAmount: 10,
    points: '263'
  },
  {
    storeName: 'Tienda Amanecer',
    storeId: '2345897016',
    customerId: '8976541',
    activeStatus: 'Active',
    deliveryDays: ['Monday'],
    deliveryService: 12,
    productList: [],
    createdDate: '2022-10-20',
    cutoffTime: '12:00',
    minimumOrderAmount: 10,
    points: '354'
  },
  {
    storeName: 'Mercadito Estrella',
    storeId: '8907123456',
    customerId: '4321876',
    activeStatus: 'Inactive',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 12,
    productList: [],
    createdDate: '2022-10-20',
    cutoffTime: '14:45',
    minimumOrderAmount: 10,
    points: '173'
  },
  {
    storeName: 'Abarrotes El Paso',
    storeId: '4569872301',
    customerId: '0192837',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 12,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '11:30',
    minimumOrderAmount: 10,
    points: '309'
  },
  {
    storeName: 'Tienda Económica',
    storeId: '0129834765',
    customerId: '6547123',
    activeStatus: 'Active',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '13:45',
    minimumOrderAmount: 10,
    points: '241'
  },
  {
    storeName: 'La Despensa',
    storeId: '6549871230',
    customerId: '2198346',
    activeStatus: 'Inactive',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '08:30',
    minimumOrderAmount: 10,
    points: '375'
  },
  {
    storeName: 'Tienda Los Lagos',
    storeId: '2187609345',
    customerId: '7896543',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '15:15',
    minimumOrderAmount: 10,
    points: '218'
  },
  {
    storeName: 'Abarrotes Providencia',
    storeId: '8743209165',
    customerId: '3452167',
    activeStatus: 'Active',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: null,
    minimumOrderAmount: 10,
    points: '332'
  },
  {
    storeName: 'Minisuper El Centro',
    storeId: '4325610987',
    customerId: '9871234',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2023-10-20',
    cutoffTime: '12:45',
    minimumOrderAmount: 10,
    points: '259'
  },
  {
    storeName: 'Tienda San Martín',
    storeId: '0987213456',
    customerId: '5647891',
    activeStatus: 'Inactive',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2023-10-20',
    cutoffTime: '14:30',
    minimumOrderAmount: 10,
    points: '187'
  },
  {
    storeName: 'Abarrotería El Roble',
    storeId: '6543298710',
    customerId: '2134987',
    activeStatus: 'Active',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2023-10-20',
    cutoffTime: '10:00',
    minimumOrderAmount: 10,
    points: '406'
  },
  {
    storeName: 'Comercial Victoria',
    storeId: '2198734056',
    customerId: '7654891',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2023-10-20',
    cutoffTime: '11:45',
    minimumOrderAmount: 10,
    points: '283'
  },
  {
    storeName: 'Tienda La Perla',
    storeId: '8765410923',
    customerId: '4321678',
    activeStatus: 'Inactive',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2023-10-20',
    cutoffTime: '13:15',
    minimumOrderAmount: 10,
    points: '164'
  },
  {
    storeName: 'Abasto Familiar',
    storeId: '4567891230',
    customerId: '0987345',
    activeStatus: 'Active',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2023-10-20',
    cutoffTime: '15:45',
    minimumOrderAmount: 10,
    points: '297'
  },
  {
    storeName: 'Tienda El Paraíso',
    storeId: '0912834567',
    customerId: '6543789',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '09:15',
    minimumOrderAmount: 10,
    points: '342'
  },
  {
    storeName: 'Mercadito San José',
    storeId: '6789054321',
    customerId: '2198765',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '12:30',
    minimumOrderAmount: 10,
    points: '275'
  },
  {
    storeName: 'Tienda Bella Vista',
    storeId: '2349871056',
    customerId: '8765432',
    activeStatus: 'Inactive',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '14:15',
    minimumOrderAmount: 10,
    points: '193'
  },
  {
    storeName: 'Abarrotes La Unión',
    storeId: '8791234056',
    customerId: '4329876',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '08:00',
    minimumOrderAmount: 10,
    points: '418'
  },
  {
    storeName: 'Minisuper Las Palmas',
    storeId: '4321098765',
    customerId: '0192837',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '10:30',
    minimumOrderAmount: 10,
    points: '251'
  },
  {
    storeName: 'Tienda El Valle',
    storeId: '0198234567',
    customerId: '6547891',
    activeStatus: 'Active',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '13:00',
    minimumOrderAmount: 10,
    points: '327'
  },
  {
    storeName: 'Abasto Nueva Era',
    storeId: '6549087123',
    customerId: '2134598',
    activeStatus: 'Inactive',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '15:30',
    minimumOrderAmount: 10,
    points: '179'
  },
  {
    storeName: 'Tienda La Amistad',
    storeId: '2198765430',
    customerId: '7890123',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '09:45',
    minimumOrderAmount: 10,
    points: '365'
  },
  {
    storeName: 'Abarrotería El Bosque',
    storeId: '8765091234',
    customerId: '4321987',
    activeStatus: 'Active',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '11:15',
    minimumOrderAmount: 10,
    points: '234'
  },
  {
    storeName: 'Comercial San Francisco',
    storeId: '4329871056',
    customerId: '0987456',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '14:00',
    minimumOrderAmount: 10,
    points: '302'
  },
  {
    storeName: 'Tienda El Mirador',
    storeId: '0198723456',
    customerId: '6547123',
    activeStatus: 'Inactive',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: null,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '08:15',
    minimumOrderAmount: 10,
    points: '168'
  },
  {
    storeName: 'Minisuper Oriente',
    storeId: '6543217890',
    customerId: '2198743',
    activeStatus: 'Active',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '10:45',
    minimumOrderAmount: 10,
    points: '396'
  },
  {
    storeName: 'Tienda La Palma',
    storeId: '2198734560',
    customerId: '7896541',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2022-10-20',
    cutoffTime: '12:15',
    minimumOrderAmount: 10,
    points: '271'
  },
  {
    storeName: 'Abarrotes Los Olivos',
    storeId: '8765432190',
    customerId: '4329871',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2022-10-20',
    cutoffTime: '15:00',
    minimumOrderAmount: 10,
    points: '348'
  },
  {
    storeName: 'Tienda La Esperanza',
    storeId: '4321908765',
    customerId: '0987123',
    activeStatus: 'Inactive',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '09:00',
    minimumOrderAmount: 10,
    points: '203'
  },
  {
    storeName: 'Mercado El Pueblo',
    storeId: '0198723465',
    customerId: '6543217',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '13:45',
    minimumOrderAmount: 10,
    points: '379'
  },
  {
    storeName: 'Tienda Brisas del Mar',
    storeId: '6543289017',
    customerId: '2134598',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '11:30',
    minimumOrderAmount: 10,
    points: '245'
  },
  {
    storeName: 'Abarrotería La Paz',
    storeId: '2198734605',
    customerId: '7896543',
    activeStatus: 'Active',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '14:30',
    minimumOrderAmount: 10,
    points: '319'
  },
  {
    storeName: 'Abasto El Jardín',
    storeId: '8790123456',
    customerId: '4329018',
    activeStatus: 'Inactive',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '08:45',
    minimumOrderAmount: 10,
    points: '174'
  },
  {
    storeName: 'Tienda Primavera',
    storeId: '4329871605',
    customerId: '0192387',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '11:00',
    minimumOrderAmount: 10,
    points: '412'
  },
  {
    storeName: 'Minisuper Los Pinos',
    storeId: '0198273465',
    customerId: '6543910',
    activeStatus: 'Active',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '13:30',
    minimumOrderAmount: 10,
    points: '287'
  },
  {
    storeName: 'Tienda El Progreso',
    storeId: '6549081723',
    customerId: '2134560',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 12,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '10:15',
    minimumOrderAmount: 10,
    points: '358'
  },
  {
    storeName: 'Abarrotes San Carlos',
    storeId: '2193478056',
    customerId: '7890432',
    activeStatus: 'Inactive',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 12,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '15:15',
    minimumOrderAmount: 10,
    points: '197'
  },
  {
    storeName: 'Comercial La Victoria',
    storeId: '8790612345',
    customerId: '4329018',
    activeStatus: 'Active',
    deliveryDays: ['Monday'],
    deliveryService: 12,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '09:30',
    minimumOrderAmount: null,
    points: '426'
  },
  {
    storeName: 'Tienda El Dorado',
    storeId: '4329871650',
    customerId: '0192387',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 12,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '12:00',
    minimumOrderAmount: 10,
    points: '265'
  },
  {
    storeName: 'Abasto San Miguel',
    storeId: '0198273456',
    customerId: '6543219',
    activeStatus: 'Inactive',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 12,
    productList: [],
    createdDate: '2023-10-20',
    cutoffTime: '14:15',
    minimumOrderAmount: 10,
    points: '193'
  },
  {
    storeName: 'Tienda Las Flores',
    storeId: '6549081237',
    customerId: '2134598',
    activeStatus: 'Active',
    deliveryDays: ['Monday'],
    deliveryService: 12,
    productList: [],
    createdDate: '2023-10-20',
    cutoffTime: '08:30',
    minimumOrderAmount: 10,
    points: '374'
  },
  {
    storeName: 'Mercadito Azul',
    storeId: '2193478560',
    customerId: '7890432',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 12,
    productList: [],
    createdDate: '2023-10-20',
    cutoffTime: '11:15',
    minimumOrderAmount: 10,
    points: '289'
  },
  {
    storeName: 'Abarrotería Modelo',
    storeId: '8790612354',
    customerId: '4329871',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 12,
    productList: [],
    createdDate: '2023-10-20',
    cutoffTime: '13:45',
    minimumOrderAmount: 10,
    points: '352'
  },
  {
    storeName: 'Tienda La Colina',
    storeId: '4329178650',
    customerId: '0192387',
    activeStatus: 'Inactive',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2023-10-20',
    cutoffTime: '15:45',
    minimumOrderAmount: 10,
    points: '209'
  },
  {
    storeName: 'Minisuper Santa Fe',
    storeId: '0192473586',
    customerId: '6543291',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2023-10-20',
    cutoffTime: '09:00',
    minimumOrderAmount: 10,
    points: '398'
  },
  {
    storeName: 'Tienda El Encanto',
    storeId: '6549018237',
    customerId: '2134598',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2023-10-20',
    cutoffTime: '12:45',
    minimumOrderAmount: 10,
    points: '247'
  },
  {
    storeName: 'Abarrotes Los Pinos',
    storeId: '2193748560',
    customerId: '7890432',
    activeStatus: 'Active',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2023-10-20',
    cutoffTime: '14:30',
    minimumOrderAmount: 10,
    points: '325'
  },
  {
    storeName: 'Comercial San Antonio',
    storeId: '8796012354',
    customerId: '4329871',
    activeStatus: 'Inactive',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2023-10-20',
    cutoffTime: '08:15',
    minimumOrderAmount: 10,
    points: '172'
  },
  {
    storeName: 'Tienda El Faro',
    storeId: '4329178056',
    customerId: '0192387',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2023-10-20',
    cutoffTime: '10:30',
    minimumOrderAmount: 10,
    points: '405'
  },
  {
    storeName: 'Abasto San Pedro',
    storeId: '0192873546',
    customerId: '6543291',
    activeStatus: 'Active',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2023-10-20',
    cutoffTime: '13:15',
    minimumOrderAmount: 10,
    points: '283'
  },
  {
    storeName: 'Tienda La Montaña',
    storeId: '6543219807',
    customerId: '2143598',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2023-10-20',
    cutoffTime: '15:00',
    minimumOrderAmount: 10,
    points: '347'
  },
  {
    storeName: 'Mercadito El Lago',
    storeId: '2198734056',
    customerId: '7809432',
    activeStatus: 'Inactive',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2022-10-20',
    cutoffTime: '09:45',
    minimumOrderAmount: 10,
    points: '189'
  },
  {
    storeName: 'Abarrotería Los Alpes',
    storeId: '8796012543',
    customerId: '4392871',
    activeStatus: 'Active',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2022-10-20',
    cutoffTime: '11:30',
    minimumOrderAmount: 10,
    points: '423'
  },
  {
    storeName: 'Tienda El Oasis',
    storeId: '4392178650',
    customerId: '0129387',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '14:15',
    minimumOrderAmount: 10,
    points: '271'
  },
  {
    storeName: 'Minisuper Valle Verde',
    storeId: '0192837546',
    customerId: '6534291',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '08:30',
    minimumOrderAmount: null,
    points: '335'
  },
  {
    storeName: 'Tienda La Cumbre',
    storeId: '6549081327',
    customerId: '2143598',
    activeStatus: 'Inactive',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '10:00',
    minimumOrderAmount: 10,
    points: '198'
  },
  {
    storeName: 'Abarrotes El Mirador',
    storeId: '2198374056',
    customerId: '7809432',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: null,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '12:30',
    minimumOrderAmount: 10,
    points: '387'
  },
  {
    storeName: 'Comercial San Luis',
    storeId: '8796012435',
    customerId: '4392871',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '15:30',
    minimumOrderAmount: 10,
    points: '254'
  },
  {
    storeName: 'Tienda Las Brisas',
    storeId: '4392187650',
    customerId: '0129387',
    activeStatus: 'Active',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '09:15',
    minimumOrderAmount: 10,
    points: '321'
  },
  {
    storeName: 'Abasto Las Palmeras',
    storeId: '0192734856',
    customerId: '6543219',
    activeStatus: 'Inactive',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '13:00',
    minimumOrderAmount: 10,
    points: '184'
  },
  {
    storeName: 'Tienda Nuevo Amanecer',
    storeId: '6549013287',
    customerId: '2143987',
    activeStatus: 'Active',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '15:15',
    minimumOrderAmount: 10,
    points: '418'
  },
  {
    storeName: 'Mercadito Las Rosas',
    storeId: '2139748605',
    customerId: '7890432',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '08:45',
    minimumOrderAmount: 10,
    points: '295'
  },
  {
    storeName: 'Abarrotería El Sol',
    storeId: '8790145263',
    customerId: '4329817',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '10:15',
    minimumOrderAmount: 10,
    points: '359'
  },
  {
    storeName: 'Tienda Los Eucaliptos',
    storeId: '4329187506',
    customerId: '0123987',
    activeStatus: 'Inactive',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '12:30',
    minimumOrderAmount: 10,
    points: '206'
  },
  {
    storeName: 'Minisuper El Parque',
    storeId: '0192743856',
    customerId: '6543219',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '14:45',
    minimumOrderAmount: 10,
    points: '392'
  },
  {
    storeName: 'Tienda Las Margaritas',
    storeId: '6549013827',
    customerId: '2143987',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '09:15',
    minimumOrderAmount: 10,
    points: '264'
  },
  {
    storeName: 'Abarrotes Los Volcanes',
    storeId: '2139748065',
    customerId: '7890432',
    activeStatus: 'Active',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '11:30',
    minimumOrderAmount: 10,
    points: '327'
  },
  {
    storeName: 'Comercial La Montaña',
    storeId: '8791045263',
    customerId: '4329817',
    activeStatus: 'Inactive',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '13:45',
    minimumOrderAmount: 10,
    points: '189'
  },
  {
    storeName: 'Tienda Las Orquídeas',
    storeId: '4329187056',
    customerId: '0123987',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '15:30',
    minimumOrderAmount: 10,
    points: '412'
  },
  {
    storeName: 'Abasto La Cascada',
    storeId: '0192743586',
    customerId: '6543219',
    activeStatus: 'Active',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '08:00',
    minimumOrderAmount: 10,
    points: '278'
  },
  {
    storeName: 'Tienda El Milagro',
    storeId: '6540913827',
    customerId: '2143987',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2023-10-20',
    cutoffTime: '10:30',
    minimumOrderAmount: 10,
    points: '345'
  },
  {
    storeName: 'Mercadito Los Girasoles',
    storeId: '2139784065',
    customerId: '7890432',
    activeStatus: 'Inactive',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2023-10-20',
    cutoffTime: '12:45',
    minimumOrderAmount: 10,
    points: '193'
  },
  {
    storeName: 'Abarrotería Las Violetas',
    storeId: '8791054263',
    customerId: '4329817',
    activeStatus: 'Active',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2023-10-20',
    cutoffTime: '14:15',
    minimumOrderAmount: 10,
    points: '429'
  },
  {
    storeName: 'Tienda La Fuente',
    storeId: '4321987056',
    customerId: '0123987',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2023-10-20',
    cutoffTime: '09:00',
    minimumOrderAmount: 10,
    points: '287'
  },
  {
    storeName: 'Minisuper La Aurora',
    storeId: '0192473586',
    customerId: '6543219',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '11:15',
    minimumOrderAmount: null,
    points: '351'
  },
  {
    storeName: 'Tienda Los Rosales',
    storeId: '6540193827',
    customerId: '2143987',
    activeStatus: 'Inactive',
    deliveryDays: ['Monday'],
    deliveryService: 12,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '13:30',
    minimumOrderAmount: 10,
    points: '175'
  },
  {
    storeName: 'Abarrotes El Manantial',
    storeId: '2139784605',
    customerId: '7890432',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 12,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '15:00',
    minimumOrderAmount: 10,
    points: '403'
  },
  {
    storeName: 'Comercial La Pradera',
    storeId: '8791054623',
    customerId: '4329817',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 12,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '09:30',
    minimumOrderAmount: 10,
    points: '281'
  },
  {
    storeName: 'Tienda San José',
    storeId: '4321798065',
    customerId: '0123987',
    activeStatus: 'Active',
    deliveryDays: ['Monday'],
    deliveryService: 12,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '09:15',
    minimumOrderAmount: 10,
    points: '432'
  },
  {
    storeName: 'Abasto La Hacienda',
    storeId: '0129467853',
    customerId: '6543219',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 12,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '11:45',
    minimumOrderAmount: 10,
    points: '278'
  },
  {
    storeName: 'Tienda El Camino',
    storeId: '7890123451',
    customerId: '5432198',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 12,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '10:30',
    minimumOrderAmount: 10,
    points: '312'
  },
  {
    storeName: 'Mercado Los Sauces',
    storeId: '4567890123',
    customerId: '9876543',
    activeStatus: 'Inactive',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2022-10-20',
    cutoffTime: '11:45',
    minimumOrderAmount: 10,
    points: '189'
  },
  {
    storeName: 'Abarrotes Santa Clara',
    storeId: '1234567899',
    customerId: '4567891',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2023-10-20',
    cutoffTime: '09:15',
    minimumOrderAmount: 10,
    points: '423'
  },
  {
    storeName: 'Tienda El Portal',
    storeId: '9876543212',
    customerId: '2345678',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2023-10-20',
    cutoffTime: '14:00',
    minimumOrderAmount: 10,
    points: '267'
  },
  {
    storeName: 'Mini Market Express',
    storeId: '2345678901',
    customerId: '8765432',
    activeStatus: 'Active',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2023-10-20',
    cutoffTime: '12:30',
    minimumOrderAmount: 10,
    points: '345'
  },
  {
    storeName: 'Tienda Nueva Era',
    storeId: '8765432102',
    customerId: '1234567',
    activeStatus: 'Inactive',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2022-10-20',
    cutoffTime: '09:45',
    minimumOrderAmount: 10,
    points: '176'
  },
  {
    storeName: 'Abarrotes El Pino',
    storeId: '3456789012',
    customerId: '7654321',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '15:30',
    minimumOrderAmount: 10,
    points: '391'
  },
  {
    storeName: 'Tienda La Colmena',
    storeId: '6543210987',
    customerId: '9876541',
    activeStatus: 'Active',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '08:15',
    minimumOrderAmount: 10,
    points: '248'
  },
  {
    storeName: 'Mercado Central Plaza',
    storeId: '5678901234',
    customerId: '4321567',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '13:45',
    minimumOrderAmount: 10,
    points: '324'
  },
  {
    storeName: 'Tienda La Estrella',
    storeId: '9012345678',
    customerId: '2109876',
    activeStatus: 'Inactive',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '10:15',
    minimumOrderAmount: 10,
    points: '156'
  },
  {
    storeName: 'Abarrotes San Rafael',
    storeId: '4321098765',
    customerId: '8765490',
    activeStatus: 'Active',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '11:30',
    points: '407'
  },
  {
    storeName: 'Tienda Los Laureles',
    storeId: '6789012345',
    customerId: '5432167',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '14:15',
    minimumOrderAmount: 10,
    points: '278'
  },
  {
    storeName: 'Minisuper El Edén',
    storeId: '1234509876',
    customerId: '9087654',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '09:30',
    minimumOrderAmount: 10,
    points: '332'
  },
  {
    storeName: 'Tienda El Bosque',
    storeId: '8901234567',
    customerId: '3456712',
    activeStatus: 'Inactive',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '12:45',
    minimumOrderAmount: 10,
    points: '194'
  },
  {
    storeName: 'Abarrotes Las Palmas',
    storeId: '2345678903',
    customerId: '7890123',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '15:45',
    minimumOrderAmount: 10,
    points: '437'
  },
  {
    storeName: 'Comercial El Triunfo',
    storeId: '7654321098',
    customerId: '2345671',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '08:30',
    minimumOrderAmount: 10,
    points: '285'
  },
  {
    storeName: 'Tienda Las Américas',
    storeId: '3210987654',
    customerId: '8901234',
    activeStatus: 'Active',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '10:45',
    minimumOrderAmount: 10,
    points: '356'
  },
  {
    storeName: 'Mercado La Cosecha',
    storeId: '6543219870',
    customerId: '4567123',
    activeStatus: 'Inactive',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '13:15',
    minimumOrderAmount: 10,
    points: '168'
  },
  {
    storeName: 'Tienda El Porvenir',
    storeId: '9087654321',
    customerId: '1230987',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '11:00',
    minimumOrderAmount: 10,
    points: '412'
  },
  {
    storeName: 'Abarrotes El Mirador',
    storeId: '4567123890',
    customerId: '6789045',
    activeStatus: 'Active',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '14:30',
    minimumOrderAmount: 10,
    points: '273'
  },
  {
    storeName: 'Tienda La Victoria',
    storeId: '7890456123',
    customerId: '2345908',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '09:00',
    minimumOrderAmount: 10,
    points: '329'
  },
  {
    storeName: 'Minisuper Los Álamos',
    storeId: '2345098761',
    customerId: '8765432',
    activeStatus: 'Inactive',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '12:15',
    minimumOrderAmount: 10,
    points: '185'
  },
  {
    storeName: 'Abarrotería Las Brisas',
    storeId: '8765432101',
    customerId: '4321567',
    activeStatus: 'Active',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '15:15',
    minimumOrderAmount: 10,
    points: '397'
  },
  {
    storeName: 'Tienda El Paraíso',
    storeId: '3456712908',
    customerId: '9087654',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '08:45',
    minimumOrderAmount: 10,
    points: '262'
  },
  {
    storeName: 'Mercado San Isidro',
    storeId: '6789054123',
    customerId: '3456789',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '11:15',
    minimumOrderAmount: 10,
    points: '344'
  },
  {
    storeName: 'Tienda Las Violetas',
    storeId: '1230945678',
    customerId: '7890123',
    activeStatus: 'Inactive',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '13:30',
    minimumOrderAmount: 10,
    points: '207'
  },
  {
    storeName: 'Abarrotes Nueva Era',
    storeId: '5678904321',
    customerId: '2345678',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '10:00',
    minimumOrderAmount: 10,
    points: '419'
  },
  {
    storeName: 'Comercial Los Cedros',
    storeId: '9012387654',
    customerId: '8765490',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2022-10-20',
    cutoffTime: '14:45',
    minimumOrderAmount: 10,
    points: '294'
  },
  {
    storeName: 'Tienda El Lirio',
    storeId: '4567890321',
    customerId: '4321098',
    activeStatus: 'Active',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2022-10-20',
    cutoffTime: '09:30',
    minimumOrderAmount: 10,
    points: '365'
  },
  {
    storeName: 'Mini Market Express',
    storeId: '7890123459',
    customerId: '9876123',
    activeStatus: 'Inactive',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2022-10-20',
    cutoffTime: '12:00',
    minimumOrderAmount: 10,
    points: '171'
  },
  {
    storeName: 'Tienda El Manantial',
    storeId: '2345671890',
    customerId: '3456789',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '15:00',
    minimumOrderAmount: 10,
    points: '428'
  },
  {
    storeName: 'Abarrotes La Gloria',
    storeId: '8901234657',
    customerId: '7654321',
    activeStatus: 'Active',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '08:15',
    minimumOrderAmount: 10,
    points: '289'
  },
  {
    storeName: 'Tienda Los Girasoles',
    storeId: '3456789210',
    customerId: '2345098',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '10:30',
    minimumOrderAmount: 10,
    points: '352'
  },
  {
    storeName: 'Mercado Las Rosas',
    storeId: '6543210789',
    customerId: '8907654',
    activeStatus: 'Inactive',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '13:00',
    minimumOrderAmount: 10,
    points: '196'
  },
  {
    storeName: 'Tienda El Bosque',
    storeId: '9087612345',
    customerId: '4321098',
    activeStatus: 'Active',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '15:30',
    minimumOrderAmount: 10,
    points: '405'
  },
  {
    storeName: 'Abarrotería Los Ángeles',
    storeId: '4321098567',
    customerId: '9087612',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '09:45',
    minimumOrderAmount: 10,
    points: '276'
  },
  {
    storeName: 'Tienda El Peral',
    storeId: '7654321908',
    customerId: '3456712',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '11:45',
    minimumOrderAmount: 10,
    points: '337'
  },
  {
    storeName: 'Minisuper El Vergel',
    storeId: '1234509867',
    customerId: '7890456',
    activeStatus: 'Inactive',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '14:00',
    minimumOrderAmount: 10,
    points: '213'
  },
  {
    storeName: 'Abarrotes San Nicolás',
    storeId: '5678901243',
    customerId: '2345908',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '08:30',
    minimumOrderAmount: 10,
    points: '446'
  },
  {
    storeName: 'Tienda La Fuente',
    storeId: '8901274563',
    customerId: '8765432',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '12:15',
    minimumOrderAmount: 10,
    points: '304'
  },
  {
    storeName: 'Comercial El Sol',
    storeId: '3456712980',
    customerId: '4321098',
    activeStatus: 'Active',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '15:15',
    minimumOrderAmount: 10,
    points: '372'
  },
  {
    storeName: 'Tienda Los Naranjos',
    storeId: '6789054132',
    customerId: '9087654',
    activeStatus: 'Inactive',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '09:15',
    minimumOrderAmount: 10,
    points: '164'
  },
  {
    storeName: 'Abarrotes La Palmera',
    storeId: '9012387645',
    customerId: '3456789',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '11:30',
    minimumOrderAmount: 10,
    points: '421'
  },
  {
    storeName: 'Tienda Las Camelias',
    storeId: '4567893210',
    customerId: '7654321',
    activeStatus: 'Active',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '13:45',
    minimumOrderAmount: 10,
    points: '286'
  },
  {
    storeName: 'Mercado El Horizonte',
    storeId: '7890456132',
    customerId: '2109876',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '16:00',
    minimumOrderAmount: 10,
    points: '359'
  },
  {
    storeName: 'Tienda La Alameda',
    storeId: '2345098716',
    customerId: '8765490',
    activeStatus: 'Inactive',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '08:45',
    minimumOrderAmount: 10,
    points: '182'
  },
  {
    storeName: 'Abarrotería Los Lirios',
    storeId: '8765432910',
    customerId: '4321567',
    activeStatus: 'Active',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '10:45',
    minimumOrderAmount: 10,
    points: '433'
  },
  {
    storeName: 'Tienda El Ensueño',
    storeId: '3210987465',
    customerId: '9087612',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2023-10-20',
    cutoffTime: '13:15',
    minimumOrderAmount: 10,
    points: '318'
  },
  {
    storeName: 'Abarrotes Villa Verde',
    storeId: '6543219087',
    customerId: '3456712',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2023-10-20',
    cutoffTime: '15:45',
    minimumOrderAmount: 10,
    points: '257'
  },
  {
    storeName: 'Tienda Los Jazmines',
    storeId: '9087654213',
    customerId: '7890456',
    activeStatus: 'Inactive',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2023-10-20',
    cutoffTime: '09:00',
    minimumOrderAmount: 10,
    points: '192'
  },
  {
    storeName: 'Mercado Las Delicias',
    storeId: '4321098756',
    customerId: '2345908',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2023-10-20',
    cutoffTime: '11:00',
    minimumOrderAmount: 10,
    points: '415'
  },
  {
    storeName: 'Tienda El Ciprés',
    storeId: '7890123546',
    customerId: '8765432',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2023-10-20',
    cutoffTime: '14:30',
    minimumOrderAmount: 10,
    points: '299'
  },
  {
    storeName: 'Abarrotería Los Robles',
    storeId: '2345098761',
    customerId: '4321098',
    activeStatus: 'Active',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2022-10-20',
    cutoffTime: '08:15',
    minimumOrderAmount: 10,
    points: '367'
  },
  {
    storeName: 'Tienda La Primavera',
    storeId: '8901234576',
    customerId: '9087654',
    activeStatus: 'Inactive',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2022-10-20',
    cutoffTime: '12:30',
    minimumOrderAmount: 10,
    points: '177'
  },
  {
    storeName: 'Comercial El Bosque',
    storeId: '3456789102',
    customerId: '3456789',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '15:00',
    minimumOrderAmount: 10,
    points: '438'
  },
  {
    storeName: 'Tienda Los Laureles',
    storeId: '6789054312',
    customerId: '7654321',
    activeStatus: 'Active',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '09:45',
    minimumOrderAmount: 10,
    points: '292'
  },
  {
    storeName: 'Minisuper La Cascada',
    storeId: '1230945678',
    customerId: '2109876',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '13:00',
    minimumOrderAmount: 10,
    points: '346'
  },
  {
    storeName: 'Abarrotes El Prado',
    storeId: '5678904321',
    customerId: '8765490',
    activeStatus: 'Inactive',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '11:15',
    minimumOrderAmount: 10,
    points: '204'
  },
  {
    storeName: 'Tienda Los Nogales',
    storeId: '9012387654',
    customerId: '4321567',
    activeStatus: 'Active',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '14:45',
    minimumOrderAmount: 10,
    points: '427'
  },
  {
    storeName: 'Mercado La Arboleda',
    storeId: '3456789012',
    customerId: '9087612',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '08:30',
    minimumOrderAmount: 10,
    points: '284'
  },
  {
    storeName: 'Tienda El Manantial',
    storeId: '7654321098',
    customerId: '3456712',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '10:15',
    minimumOrderAmount: 10,
    points: '361'
  },
  {
    storeName: 'Abarrotería Las Acacias',
    storeId: '2109876543',
    customerId: '7890456',
    activeStatus: 'Inactive',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '12:45',
    minimumOrderAmount: 10,
    points: '188'
  },
  {
    storeName: 'Tienda El Álamo',
    storeId: '6543210987',
    customerId: '2345908',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '15:30',
    minimumOrderAmount: 10,
    points: '409'
  },
  {
    storeName: 'Comercial La Alameda',
    storeId: '9087654321',
    customerId: '8765432',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '09:15',
    minimumOrderAmount: 10,
    points: '273'
  },
  {
    storeName: 'Tienda Los Abetos',
    storeId: '4321098765',
    customerId: '4321098',
    activeStatus: 'Active',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '11:45',
    minimumOrderAmount: 10,
    points: '339'
  },
  {
    storeName: 'Abarrotes El Mirador',
    storeId: '8765432109',
    customerId: '9087654',
    activeStatus: 'Inactive',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '14:15',
    minimumOrderAmount: 10,
    points: '165'
  },
  {
    storeName: 'Tienda La Cabaña',
    storeId: '3210987654',
    customerId: '3456789',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '08:00',
    minimumOrderAmount: 10,
    points: '442'
  },
  {
    storeName: 'Mercado El Vergel',
    storeId: '7890123456',
    customerId: '7654321',
    activeStatus: 'Active',
    deliveryDays: ['Monday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '10:30',
    minimumOrderAmount: 10,
    points: '296'
  },
  {
    storeName: 'Tienda Los Claveles',
    storeId: '2345678901',
    customerId: '2109876',
    activeStatus: 'Active',
    deliveryDays: ['Monday', 'Tuesday', 'Wednesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '13:30',
    minimumOrderAmount: 10,
    points: '354'
  },
  {
    storeName: 'Abarrotería San Lorenzo',
    storeId: '6789012345',
    customerId: '8765490',
    activeStatus: 'Inactive',
    deliveryDays: ['Monday', 'Tuesday'],
    deliveryService: 24,
    productList: [],
    createdDate: '2024-01-01',
    cutoffTime: '15:15',
    minimumOrderAmount: 10,
    points: '213'
  }
];
